import APIClient from '@/shared/http/clients/api'

const resourceName = 'REEmpreendimento'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const GetTipoEmpreedimento = (EmpreendimentoId, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetTipoEmpreedimento/${EmpreendimentoId}`, data, config)
const GetAllNotPaging = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const GetAllPagingSearch = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/Search?limit=${limit}&index=${index}`, data, config)
const searchWithFilter = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/filtro?limit=${limit}&index=${index}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/${id}`, config)
const Search = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/search`, data, config)
const GetEnum = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetEnum`, data, config)
const GetEnumType = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetEnumType`, data, config)
const GetAllPaging = (limit, index, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}?limit=${limit}&index=${index}`, data, config)
const GetByName = (value, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetByName/${value}`, config)
const calculaSalesEnterprise = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetAllRelatorio`, data, config)
const GetEmpreendimentoByFiltro = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/filtro?limit=${limit}&index=${index}`, data, config)
const GetImagem = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetImagem/${id}`, data, config)
const GetAllRelatorioSearch = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetAllRelatorioSearch`, data, config)
const GetAllEnterpriseNotCom = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllEnterpriseNotCom`, data, config)
const GetEnterprisesFilter = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetEnterprisesFilter`, data, config)
const GetStatesFilter = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetStatesFilter`, data, config)
const GetCityByNameEnterprise = (nome, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetCityByNameEnterprise/${nome}`, data, config)
const RemovePlantaEnterprise = (id, data = {}, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/RemovePlantaEnterprise/${id}`, data, config)
const GetPlantaEnterprise = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetPlantaEnterprise/${id}`, data, config)
const SavePlantaEnterprise = (id, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/SavePlantaEnterprise/${id}`, data, config)
const GetEmpreendimentoByInsumos = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetEmpreendimentoByInsumos`, data, config)
const GetEmpreendimento = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetEmpreendimento`, data, config)
const GetTipoByEmpreendimentoId = (EmpreendimentoId, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetTipoByEmpreendimentoId/${EmpreendimentoId}`, data, config)

const EnterpriseRepository = {
  GetAll,
  GetEmpreendimento,
  GetTipoEmpreedimento,
  GetImagem,
  Create,
  Update,
  Delete,
  Search,
  GetEnumType,
  GetAllPagingSearch,
  GetEnum,
  GetAllPaging,
  GetByName,
  calculaSalesEnterprise,
  GetEmpreendimentoByFiltro,
  searchWithFilter,
  GetAllNotPaging,
  GetAllEnterpriseNotCom,
  GetAllRelatorioSearch,
  GetEnterprisesFilter,
  GetStatesFilter,
  GetCityByNameEnterprise,
  RemovePlantaEnterprise,
  GetPlantaEnterprise,
  SavePlantaEnterprise,
  GetEmpreendimentoByInsumos,
  GetTipoByEmpreendimentoId
}

export default EnterpriseRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/enterprise.js